// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSY08voosk7pAcWDa19SVwagYrmpIiLEw",
  authDomain: "sellingstuff-3c0b4.firebaseapp.com",
  projectId: "sellingstuff-3c0b4",
  // IMPORTANT:
  // The Storage bucket name must exactly match the bucket provisioned in Firebase Console.
  // If this is wrong, uploads can fail with CORS preflight 404 / `storage/unknown`.
  storageBucket: "sellingstuff-3c0b4.firebasestorage.app",
  messagingSenderId: "873809104283",
  appId: "1:873809104283:web:1ca6492e080998aca9253e",
  measurementId: "G-YCLXJ51LQY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
// Use an explicit gs:// bucket URL so the SDK targets the right bucket consistently.
const storage = getStorage(app, `gs://${firebaseConfig.storageBucket}`);

export { auth, db, functions, storage };
export default app;